import config from "shared/config";

// Because assets do not get loaded in test/JSDOM env, we wrap it
export function testSafeAsset(assetPath, replacementPath = "/dev/null") {
  return config.isJsTest ? replacementPath : assetPath;
}
